module.exports = __webpack_public_path__ + "img/hotelBg2.9cec1d8c.png";